import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES,
  FANCY_SLIDE_CONTENT_LAYOUT as layouts, PERCENTAGES, BACKGROUND_IMAGE_POSITION } from 'shared/constants';

const propsSchema = [
  {
    key: 'slides',
    label: 'Slides',
    type: types.ARRAY,
    children: [
      {
        key: 'bg_img',
        label: 'Background Image',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Image URL',
            type: types.TEXT
          },
          {
            key: 'focal_image',
            label: 'Focal Image',
            type: types.TEXT
          },
          {
            key: 'mobile_image',
            label: 'Mobile Image',
            type: types.TEXT
          },
          {
            key: 'dark_overlay',
            label: 'Dark Overlay',
            type: types.ENUM,
            options: PERCENTAGES
          },
          {
            key: 'position',
            label: 'Background Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          },
          {
            key: 'background_color',
            label: 'Background Color',
            type: types.COLOR_PICKER
          }
        ]
      },
      {
        key: 'bg_video',
        label: 'Background Video',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Video URL',
            type: types.TEXT
          },
          {
            key: 'cover',
            label: 'Cover URL',
            type: types.TEXT
          },
          {
            key: 'loop',
            label: 'Loop',
            type: types.BOOLEAN
          },
          {
            key: 'play_on_enter',
            label: 'Play on Enter',
            type: types.BOOLEAN
          }
        ]
      },
      {
        key: 'content',
        label: 'Content',
        type: types.OBJECT,
        children: [
          {
            key: 'color_theme',
            label: 'Color Theme',
            type: types.ENUM,
            options: COMPONENT_COLOR_THEMES
          },
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT
          },
          {
            key: 'description',
            label: 'Description',
            type: types.TEXT
          },
          {
            key: 'layout',
            label: 'Layout',
            type: types.ENUM,
            options: layouts
          },
        ]
      }
    ]
  }
];

const defaultProps = {
  slides: [
    {
      bg_img: {
        url: '',
        focal_image: '',
        mobile_image: 'https://genesis-cdn.ff.com/product/07_design/faraday-future-ff-91-zero-gravity-seats.png',
        dark_overlay: 0,
        position: 'CENTER CENTER',
        background_color: '#f0f0f0'
      },
      bg_video: {
        url: 'https://genesis-cdn.ff.com/product/07_design/04.mp4',
        cover: 'https://genesis-cdn.ff.com/product/07_design/faraday-future-ff-91-zero-gravity-seats.png',
        loop: false,
        play_on_enter: true
      },
      content: {
        color_theme: 'LIGHT',
        title: 'Defy Gravity',
        description: 'In zero gravity, the human body naturally assumes what NASA scientists call the Neutral Body Posture. Our rear seats were designed to these specifications and enable the ideal distribution of your body’s weight. For even more comfort, the ventilated seats can massage away pressure and stress.',
        layout: 'TOP LEFT'
      }
    },
    {
      bg_img: {
        url: '',
        focal_image: 'https://genesis-cdn.ff.com/product/07_design/faraday-future-spacious-ff-91.png',
        mobile_image: '',
        dark_overlay: 0,
        position: 'CENTER CENTER',
        background_color: '#f0f0f0'
      },
      bg_video: {
        url: '',
        cover: '',
        loop: false,
        play_on_enter: true
      },
      content: {
        color_theme: 'LIGHT',
        title: 'A New Era of Interiors',
        description: 'The welcome absence of a gas powertrain allowed us to gain space that traditional vehicles don’t have ability to access. The expansive EV interior measures 151 cubic feet, providing a lounge-like environment to spend time resting or being more productive.',
        layout: 'TOP LEFT'
      }
    }
  ]
};

export default {
  title: 'Fancy Slide Show',
  id: 'FancySlideShow',
  propsSchema,
  defaultProps
};
